import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { PRICE } from '../data/content';
const recap = ['6 冊教材', '5 份附送', '240 頁', '小四至中三'];
const reassurances = ['即時下載', '工作紙可直接列印', '7 天滿意保證'];
export function FinalCta() {
  return <section className="relative w-full overflow-hidden bg-seyes px-8 py-24 sm:px-14 sm:py-32" data-id="element-114" data-mp="19cmcaewmxvf3">
      <div aria-hidden="true" className="pointer-events-none absolute inset-y-0 left-4 w-px bg-red-300 sm:left-8 lg:left-12" data-id="element-115" data-mp="15fq9gcpbzi8q" />
      <div className="relative mx-auto max-w-3xl text-center" data-id="element-116" data-mp="1eek1rqvmpmgh">
        <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-117" data-mp="1ebxttq4tt4xq">
          你的設計與科技課，<em className="text-red-700" data-id="element-118" data-mp="1o3v5sz3ns0xi">今天就可以準備好。</em>
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-slate-900/75" data-id="element-119" data-mp="1o4n44hon4crh">
          不用再找專題、自己做每一份工作紙、把週末都花在備課上——你有一套整理好的全年設計與科技教材。把時間留給真正重要的事：
        </p>
        <p className="mt-6 font-serif text-2xl italic leading-snug text-slate-900 sm:text-3xl" data-id="element-120" data-mp="1x5kye89a15wv">
          你的學生。你的課堂。你在學校以外的生活。
        </p>

        <ul className="mt-10 flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm font-medium text-slate-900/70" data-id="element-121" data-mp="n7p6tg60bfku">
          {recap.map(item => <li key={item} data-id="element-122" data-mp="x421ag9dlxgn">{item}</li>)}
        </ul>

        <p className="mt-8 font-serif text-6xl leading-none tracking-tight text-slate-900 sm:text-7xl" data-id="element-123" data-mp="x2h38gnurwe1">{PRICE}</p>
        <p className="mt-3 text-sm text-slate-900/70" data-id="element-124" data-mp="120se8upvwcxu">一次付款——無需訂閱。</p>

        <div className="mt-8 flex justify-center" data-id="element-125" data-mp="163p1wzua6z8n">
          <CtaButton className="w-full sm:w-auto" data-id="element-126" data-mp="1b3joir70x2nw" />
        </div>

        <ul className="mt-6 flex flex-wrap justify-center gap-x-6 gap-y-1.5 text-sm text-slate-900/70" data-id="element-127" data-mp="1b1qlrmzj72l6">
          {reassurances.map(item => <li key={item} className="flex items-center gap-2" data-id="element-128" data-mp="1ktd03s761hs5">
              <CheckIcon className="h-4 w-4 text-red-700" aria-hidden="true" data-id="element-129" data-mp="1ksl4wihhdm2e" />
              {item}
            </li>)}
        </ul>
      </div>
    </section>;
}